// Helper for Format-products (Digital/Fysisk) on the product page.
//
// 1) Pre-selects the Format axis from a ?format= URL parameter, e.g.
//    /products/waisty?format=fysisk — so links from the "Fysiske Mønstre"
//    collection land on the physical format pre-selected.
//
// 2) Auto-corrects an invalid combination: when switching Format leaves an
//    unavailable size selected (e.g. "Fysisk + M", which doesn't exist), it
//    automatically selects the only available value ("Alle størrelser
//    inkludert"). This is required because that pill is hidden behind the
//    info box, so the shopper can't pick it manually.
//
// Scoped to the main product picker on Format-products only
// (variant-picker--hide-unavailable), so the rest of the store is untouched.
(function () {
  const PICKER_SELECTOR = 'variant-picker[data-template-product-match="true"].variant-picker--hide-unavailable';

  function getPicker() {
    return document.querySelector(PICKER_SELECTOR);
  }

  /**
   * If the checked value in any axis is unavailable but an available
   * alternative exists, select that alternative. Returns true if it acted.
   */
  function autoCorrect(picker) {
    if (!picker) return false;
    for (const fieldset of picker.querySelectorAll('fieldset')) {
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const checked = radios.find((radio) => radio.checked);
      if (!checked || checked.dataset.optionAvailable !== 'false') continue;

      const available = radios.find((radio) => radio.dataset.optionAvailable === 'true');
      if (available && available !== checked) {
        available.checked = true;
        available.dispatchEvent(new Event('change', { bubbles: true }));
        return true; // the resulting variant:update re-runs this check
      }
    }
    return false;
  }

  /**
   * Decides which format to pre-select: explicit ?format= wins; otherwise, if
   * the shopper arrived from the "Fysiske Mønstre" collection, default to the
   * physical format. The referrer fallback means it works even if the collection
   * link didn't carry the ?format= parameter.
   */
  function getWantedFormat() {
    const param = (new URLSearchParams(window.location.search).get('format') || '').trim().toLowerCase();
    if (param) return param;
    if (/fysiske-monstre/i.test(document.referrer || '')) return 'fysisk';
    return '';
  }

  /** Selects the requested Format value (Digital/Fysisk). */
  function preselectFormat(picker) {
    const wanted = getWantedFormat();
    if (!wanted || !picker) return false;

    let formatFieldset = null;
    for (const fieldset of picker.querySelectorAll('fieldset')) {
      const legend = fieldset.querySelector('legend');
      if (legend && legend.textContent.trim().toLowerCase().startsWith('format')) {
        formatFieldset = fieldset;
        break;
      }
    }
    if (!formatFieldset) return false;

    for (const input of formatFieldset.querySelectorAll('input[type="radio"]')) {
      const value = (input.getAttribute('value') || input.getAttribute('aria-label') || '').toLowerCase();
      if (value.includes(wanted)) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return true; // change triggers a variant:update; autoCorrect runs there
        }
        return false;
      }
    }
    return false;
  }

  // Re-run auto-correct every time the picker re-renders after a variant change.
  document.addEventListener('variant:update', () => autoCorrect(getPicker()));

  function init() {
    const picker = getPicker();
    if (!picker) return false;
    // If we changed the format via URL, the variant:update it triggers will
    // handle auto-correct. Otherwise, fix any unavailable initial state now.
    if (!preselectFormat(picker)) autoCorrect(picker);
    return true;
  }

  function run() {
    if (init()) return;
    // The variant-picker custom element may upgrade slightly after load; retry briefly.
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (init() || attempts >= 10) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
